export default "__VITE_ASSET__9c475796__"